module.exports = __webpack_public_path__ + "a17d279f/img/boston-lights.a623432f.png";